<template>
  <div class="loader-wrap" :class="{ 'loader-wrap_inverse': inverse }" role="status" aria-label="Загрузка">
    <div class="loader" :class="sizeClass"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    /** Тёмный вариант для светлого текста на тёмном фоне */
    inverse: { type: Boolean, default: false },
    /** sm | md (default) | lg */
    size: { type: String, default: 'md' }
  },
  computed: {
    sizeClass() {
      return this.size && this.size !== 'md' ? `loader_${this.size}` : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.loader-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  min-height: 80px;

  &_inverse .loader {
    border-color: rgba(255, 255, 255, 0.2);
    border-top-color: $color-accent-teal;
  }
}

.loader {
  width: 40px;
  height: 40px;
  border: 3px solid $color-border;
  border-top-color: $color-accent-teal;
  border-radius: 50%;
  animation: loader-spin 0.85s linear infinite;

  &_sm {
    width: 28px;
    height: 28px;
    border-width: 2px;
  }

  &_lg {
    width: 52px;
    height: 52px;
    border-width: 4px;
  }
}

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
